import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出");

import { computed, watch, ref } from 'vue';
import { getVexTableProps } from '@/config';
import { getActivityWithdrawList, exportForAsync } from '@/request';
export default {
  name: 'record-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    activityId: String
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    watch(() => props.activityId, () => {
      var _table$value;

      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
    });
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        title: '活动名称',
        field: 'activityName'
      }, {
        title: '活动类型',
        field: 'activityType'
      }, {
        title: '活动发起方',
        field: 'activityPublisher'
      }, {
        title: '活动时间',
        field: 'activityTime'
      }, {
        title: '订单编号',
        field: 'orderCode'
      }, {
        title: '订单金额',
        field: 'orderAmount'
      }, {
        title: '奖励金额',
        field: 'rewardAmount'
      }, {
        title: '业务员名称',
        field: 'linkMan'
      }, {
        title: '业务员团队',
        field: 'supplierName'
      }, {
        title: '联系方式',
        field: 'linkPhone'
      }, {
        title: '获取时间',
        field: 'getTime'
      }, {
        title: '提现状态',
        field: 'withdrawStatus'
      }, {
        title: '提现时间',
        field: 'withdrawTime'
      }, {
        title: '微信昵称',
        field: 'nickName'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getActivityWithdrawList({
              page: page.currentPage,
              pageSize: page.pageSize,
              activityId: props.activityId
            }).then(data => {
              total.value = data.data.totalSize;
              res({
                total: data.data.totalSize,
                result: data.data.activityWithdrawRecordList
              });
            });
          })
        }
      }
    });
    const total = ref(0);

    function exportHandle() {
      let url = `/admin/activity/redPacket/exportActivityWithdrawRecordList.json?activityId=${props.activityId}`;
      exportForAsync({
        __repeat: true,
        __warn: true,
        activityId: props.activityId,
        modularflag: 'redPacketActivityWithdrawRecord',
        fileName: '红包发放记录',
        count: total.value,
        methodName: '/admin/activity/redPacket/exportActivityWithdrawRecordList.json'
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "查看发放记录",
        width: "90%",
        top: "5vh"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), {
          tools: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: exportHandle
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};